<template>
    <BaseCard>
        <template #card-body>
            <template v-if="!statusData.length">
                <EmptyPage 
                    state="empty_custom" 
                    icon-name="report" 
                    type="data"
                    title=" No data available." 
                />
            </template>
            <template v-else>
                <div>
                    <slot name="header-caption" />

                    <div class="report__status">
                        <div v-for="(item, index) in statusData" :key="index" class="report__status__item">
                            <div class="flex align-items-baseline">
                                <span 
                                    class="tag badge rounded-pill mr--5"  
                                    :class="[statusMap[item.id]?.tag || '']" 
                                />
                                <div class="ml--5">
                                    <span class="text--xs text-gray-400 text--capitalize">
                                        {{ item.id }}
                                    </span>
                                    <p class="text--base text--medium text-gray-700">
                                        {{ item.count }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>                
        </template>
    </BaseCard>
</template>

<script>
import { BaseCard, EmptyPage } from "@/components/ui/index";
import { 
    projectStatusMap, 
    invoiceStatusMap,
    clientStatusMap,
} from "@/utils/enums";

export default {
    name: "StatusReport",

    components: {
        BaseCard,
        EmptyPage,
    },

    props: {
        statusData: {
            type: Array,
            default: () => [],
        },
        field: {
            type: String,
            default: "",
            validator: (value) => {
                return ["client", "project", "invoice"].includes(value);
            },
        },
        iconName: {
            type: String,
            default: "report",
        },
    },

    computed: {
        statusMap() {                        
            switch (this.field) {
            case "client":
                return clientStatusMap;
                
            case "project":
                return projectStatusMap;

            case "invoice":
                return invoiceStatusMap;

            default:
                return null;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
    .tag {
        border-radius: 50%;
        height: 7px;
        width: 7px;
        padding: 0.1rem;

        &--cornsilk {
           background:  rgb(210, 105, 30)!important;
        }
   
        &--purple {
            background: #6b21a8 !important;
        }
    
        &--pink {
            background: #DA7DA0 !important;
        }
    
        &--red {
            background: rgb(144, 22, 69) !important;
        }
        
        &--green {
            background: #228d2d !important;
        }
    
        &--blue {
            background: #4285F4 !important;
        }
    
        &--yellow {
            background: #e8bd0d !important;
        }
    
        &--grey {
            background: #c5c5c5 !important;
        }
    }

    .report__status {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 15px;

        &__item {
            min-width: 100px;
        }
    }
</style>